var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$store.getters.getLayers(_vm.params))?_c('div',[_c('FiltreLayersGroup',{attrs:{"layers":_vm.params.list}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }